import { Button, Layout, Space } from "antd";
import { useState, useEffect } from "react";
import { CreateRadiologyJournalDto, RadiologyJournal, UpdateRadiologyJournalDto } from "../../api";
import { BASE_PATH } from "../../api/base";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { EditableTable } from "../../components/editable-table/EditableTable";
import { fetchRadiologyPointsByOrganizationidAsync } from "../radiologyPoints/RadiologyPointsSlice";
import { RadiologyJournalsForm } from "./components/RadiologyJournalsForm";
import { RadiologyJournalsColumns } from "./form/columns";
import { createRadiologyJournalAsync, updateRadiologyJournalAsync, selectRadiologyJournals, deleteRadiologyJournalAsync, fetchRadiologyJournalsByQuarterAsync } from "./RadiologyJournalsSlice";
import { RadiologyJournalForm } from "./components/RadiologyJournalForm";

interface RadiologyJournalsComponentProps {
  organizationId?: string;
  year?: number;
  quarter?: number;
}

export const RadiologyJournalsComponent: React.FC<RadiologyJournalsComponentProps> = ({ organizationId, year, quarter }) => {
  const dispatch = useAppDispatch();
  const journals = useAppSelector(selectRadiologyJournals);
  const radiologyJournals = journals.map((journal) => (
    {
    ...journal,
    point: `№${journal?.pollutant?.point?.no} ${journal?.pollutant?.point?.name} (${journal?.pollutant?.point?.latitude}° ш. ${journal?.pollutant?.point?.longitude}° д.)` || undefined,
  }));

  const [visibleForms, setFormsVisible] = useState(false);
  const [visibleForm, setFormVisible] = useState(false);

  useEffect(() => {
    if (organizationId) {
      if (year && quarter) {
        dispatch(fetchRadiologyJournalsByQuarterAsync({ organizationId, year, quarter }));
      } else {
        dispatch(fetchRadiologyJournalsByQuarterAsync({ organizationId, year: new Date().getFullYear(), quarter: Math.ceil(new Date().getMonth() / 3) }));
      }

      dispatch(fetchRadiologyPointsByOrganizationidAsync(organizationId));
    }
  }, [year, quarter, organizationId, dispatch]);

  const onUpdate = async (radiologyJournal: UpdateRadiologyJournalDto, id: string) => {
    return dispatch(updateRadiologyJournalAsync({ radiologyJournal, id })).then((res: any) => {
      if (!res.error) {
        if (organizationId) {
          if (year && quarter) {
            dispatch(fetchRadiologyJournalsByQuarterAsync({ organizationId, year, quarter }));
          } else {
            dispatch(fetchRadiologyJournalsByQuarterAsync({ organizationId, year: new Date().getFullYear(), quarter: Math.ceil(new Date().getMonth() / 3) }));
          }
        }
        return true;
      }
      return false;
    });
  };

  const onCreateRadiologyJournal = (radiologyJournal: CreateRadiologyJournalDto) => {
    if (!organizationId || !year || !quarter) return;

    dispatch(createRadiologyJournalAsync({ ...radiologyJournal, organizationId, year, quarter })).then((res: any) => {
      if (!res.error) {
        setFormVisible(false);
        setFormsVisible(false);
      }
    });
  };

  const deleteRadiologyJournals = (radiologyJournal: RadiologyJournal) => {
    return dispatch(deleteRadiologyJournalAsync({ radiologyJournal })).then((res: any) => {
      if (!res.error) {
        return true;
      }
      return false;
    });
  }

  const addButtons = (
    <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
      <Button onClick={() => setFormVisible(true)} block type="dashed" className="">
        + Добавить запись в журнал
      </Button>
      <Button onClick={() => setFormsVisible(true)} block type="dashed">
        + Добавить несколько записей в журнал
      </Button>
    </Space>
  )

  return (
    <Layout className="bg-white p-4 rounded-lg">
      {visibleForms && <RadiologyJournalsForm visible={visibleForms} setVisible={setFormsVisible} onCreateRadiologyJournal={onCreateRadiologyJournal} organizationId={organizationId} />}
      {visibleForm && <RadiologyJournalForm visible={visibleForm} setVisible={setFormVisible} onCreateRadiologyJournal={onCreateRadiologyJournal} organizationId={organizationId} />}
      <div className="table-responsive">
        <EditableTable<RadiologyJournal, UpdateRadiologyJournalDto>
          onSave={onUpdate}
          onDelete={deleteRadiologyJournals}
          entityColumns={RadiologyJournalsColumns()}
          dataSource={radiologyJournals}
          footer={() => addButtons}
        />
      </div>
      <Button href={`${BASE_PATH}/radiology-journal/report/organization/${organizationId}`} block type="primary" ghost>
        Получить отчёт
      </Button>
    </Layout>
  );
};
